
import { Component, Input, OnInit, input } from "@angular/core";
import { MatSelectChange } from "@angular/material/select";
import { ColumnTypeEnum, FilterItemDto, FilterTypeEnum, GridColumnDto } from "../../../core/services/api.service";

@Component({
    template: '',
    standalone: false
})
export abstract class GridFilterBaseComponent {
    
    readonly id = input<string>(undefined);
    // TODO: Skipped for migration because:
    //  Your application code writes to the input. This prevents migration.
    @Input() filterItem: FilterItemDto;
    readonly columns = input<GridColumnDto[]>(undefined);

    columnTypes = ColumnTypeEnum;
    filterTypes = FilterTypeEnum;

    columnChanged(event: MatSelectChange) {
        let column = this.columns().find(x => x.columnName == event.value);

        this.filterItem.column = column.columnName;
        this.filterItem.columnType = column.columnType;
        this.filterItem.value1 = null;
        this.filterItem.value2 = null;
        this.filterItem.meta = null;
        this.filterItem.filterType = FilterTypeEnum.Equals;
    }
}
